var map = {
	"./about.png": "335a",
	"./bat-white.png": "4c96",
	"./bat.png": "8a24",
	"./bigDisco.png": "c6fc",
	"./carlsberg-white.png": "ff24",
	"./carlsberg.png": "e046",
	"./instr/appGallery.svg": "2f2d",
	"./instr/appStore.svg": "332e",
	"./instr/bigPhone.svg": "8ab2",
	"./instr/googlePlay.svg": "8f58",
	"./instr/phone1.png": "8403",
	"./instr/phone2.png": "4569",
	"./instr/phoneLaptop.png": "edf1",
	"./intro.jpg": "1c30",
	"./jelzin.png": "2489",
	"./monkey-white.png": "17f2",
	"./monkey.png": "9260",
	"./reasons/reasons_1.svg": "5f68",
	"./reasons/reasons_2.svg": "2d79",
	"./reasons/reasons_3.svg": "6176",
	"./reasons/reasons_4.svg": "688f",
	"./reasons/reasons_5.svg": "ba0c",
	"./reasons/reasons_6.svg": "8e6f",
	"./tiger.png": "4d6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "72dd";